import { SHOP_LINKS, ABOUT_US_LINKS } from '@/features/shared/constants/hyperlinks'
import {
  SAME_DAY_DELIVERY_LINKS,
  MEMBERSHIP_POPOVER_LINKS,
} from '@/features/shared/constants/layouts'
import { VisuallyHidden } from '@/features/shared/elements/VisuallyHidden'
import { getUniversalNavCategories } from '@/features/shop/services/UniversalCategories/utils/getUniversalNavCategories'
import { routes } from '@shared/constants/routes'

export const GlobalHeaderVisuallyHiddenLinksSEO = () => {
  const visuallyHiddenLinks = [
    ...SAME_DAY_DELIVERY_LINKS.map((link) =>
      link.name === 'View all' ? { name: 'View all Shipt Same-Day Delivery', url: link.url } : link,
    ),
    ...SHOP_LINKS,
    {
      name: 'View all categories',
      url: routes.UNGATED_CATEGORY_HUB.url,
    },
    ...getUniversalNavCategories().map((category) => ({
      name: category.name,
      url: category.url,
    })),
    ...MEMBERSHIP_POPOVER_LINKS,
    ...ABOUT_US_LINKS,
  ]
  return (
    <VisuallyHidden aria-hidden>
      {visuallyHiddenLinks.map((link) => (
        <span key={link.name}>
          <a tabIndex={-1} href={link.url}>
            {link.name}
          </a>
        </span>
      ))}
    </VisuallyHidden>
  )
}
